import * as React from 'react';
import { Link } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HomeIcon from '@mui/icons-material/Home';

export const GlobalError = () => {
	return (
		<div className="min-h-screen bg-gradient-to-br from-gray-50 to-white flex items-center justify-center px-6">
			<div className="text-center max-w-md">
				<div className="w-24 h-24 bg-gradient-to-br from-primary-100 to-primary-200 rounded-full flex items-center justify-center mx-auto mb-8">
					<ErrorOutlineIcon className="text-primary-500" sx={{ fontSize: 48 }} />
				</div>
				<h1 className="font-playfair-custom-bold text-4xl text-gray-900 mb-4">
					Ups!
				</h1>
				<p className="text-gray-600 font-montserrat-custom-medium mb-8">
					Coś poszło nie tak... Strona, której szukasz, nie istnieje lub została przeniesiona.
				</p>
				<Link
					to="/"
					className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-primary-500 to-primary-600 text-white font-bold rounded-full shadow-soft hover:shadow-soft-lg hover:scale-105 transition-all duration-300"
				>
					<HomeIcon fontSize="small" />
					Powróć do strony głównej
				</Link>
			</div>
		</div>
	);
};
